module.exports = __webpack_public_path__ + "r-v3/img/ico_white_noise_white.0487c94e.svg";